import { Injectable } from '@angular/core';
import { Http,Response } from '@angular/http';
import { SeguridadService } from './seguridad.service';
import { AppSettings } from '../_models/settings.models';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

@Injectable()
export class TiendaService {

  constructor(private http: Http,
              private seguridad: SeguridadService) { }


    getTiendaAplicaciones(id_role:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({id_role:id_role, tokenid: userToken, action: "TiendaGetStoreApps", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    setUserRoleApp(id_role:number,id_app:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({id_role:id_role,id_app:id_app, tokenid: userToken, action: "TiendaSetUserRoleApp", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    deleteUserRoleApp(id_role:number,id_app:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({id_role:id_role,id_app:id_app, tokenid: userToken, action: "TiendaDeleteUserRoleApp", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }

    deleteRoleMaestra(id_role:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({id_role:id_role, tokenid: userToken, action: "TiendaDeleteRoleMaestra", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }    

    actualizarUsuariosRoleApps(id_role:number){

      let userToken : string = localStorage.getItem('currentUserToken');

      return this.http.post(AppSettings.API_URL, JSON.stringify({id_role:id_role, tokenid: userToken, action: "TiendaActualizarUsuarioApps", api_keytoken: AppSettings.API_KEYTOKEN }))
          .map((response: Response) => {

              if (!this.seguridad.getError(response)){ //si no hay error

                return response;

              }

          });
    }   

}



// WEBPACK FOOTER //
// ./src/app/_services/tienda.service.ts